module.exports = __webpack_public_path__ + "static/karussel6-86d98dd2a062ac38c4c675ab04bade2a.jpg";